import Cookies from 'js-cookie'
import { Message } from 'element-ui'

import { resolveTokenCookie } from '@/utils/tokenCookie'

// Login action reject 时用它，移动端登录页据此区分"cookie 存不下"和"网络异常"。
// 抽成常量是因为那是跨文件的约定，靠字面量对上的话，改了一边不会有任何东西报错。
export const TOKEN_PERSIST_ERROR = '登录态无法保存'

// 名字和属性在模块顶层解析一次，读 / 写 / 删共用同一份。
//
// 共用 options 不是风格问题：__Host- 前缀的 cookie，删除动作发出的也是一条 Set-Cookie，
// 同样要过前缀校验（带 Secure、Path=/、不带 Domain）。少传一个 secure 就删不掉，而后端
// logout 是空实现、JWT 不会失效，于是"退出登录"会变成刷新一下又自动登入。共用同一个对象
// 让写和删的属性在结构上不可能分叉。
const { name: TokenName, options: TokenCookieOptions } = resolveTokenCookie(
  window.location.protocol,
  window.location.hostname
)

export function getToken() {
  // 只从 cookie 读。曾经有过 localStorage 回退，但 localStorage 是 origin 级的，
  // 一旦被写脏，getToken() 会恒真并拿到垃圾值，把路由守卫锁进
  // GetInfo 失败 → FedLogOut → next('/') 的死循环且 /login 不可达。
  return Cookies.get(TokenName) || ''
}

// js-cookie 在浏览器拒绝这条 cookie 时不抛异常也不返回错误，只是静默地什么都没发生。
// 那种失败的表现是"登录成功了但立刻被守卫弹回登录页"的死循环，没有任何提示。
// 回读一次，把它变成看得见的错误。
export function setToken(token) {
  Cookies.set(TokenName, token, TokenCookieOptions)
  if (Cookies.get(TokenName) !== token) {
    console.error('[auth] 登录态写入失败：浏览器拒绝了 ' + TokenName)
    Message.error('登录态无法保存，请检查浏览器的 cookie 设置')
    return false
  }
  return true
}

export function removeToken() {
  Cookies.remove(TokenName, TokenCookieOptions)
  if (Cookies.get(TokenName) !== undefined) {
    console.error('[auth] 登出失败：' + TokenName + ' 没有被删除')
    Message.error('登出未完成，请手动清除浏览器 cookie')
    return false
  }
  return true
}
